import React, { useState } from "react";
import { BUCKETS, ROW_LABELS } from "./taxBucketContent";

const Cell = ({ k, v }) =>
  k === "questions" ? (
    <ul className="space-y-1">{v.map((q) => <li key={q} className="flex gap-2"><span className="text-exodus-gold">?</span>{q}</li>)}</ul>
  ) : (
    <p>{v}</p>
  );

export default function BucketComparison() {
  const [view, setView] = useState("compare");
  const [active, setActive] = useState("taxable");
  const b = BUCKETS.find((x) => x.key === active);

  return (
    <section data-testid="bucket-comparison">
      <div className="flex flex-wrap items-center gap-2 mb-8">
        <button data-testid="bucket-view-compare" onClick={() => setView("compare")} className={`px-4 py-2 text-xs eyebrow border transition-colors ${view === "compare" ? "border-exodus-gold bg-exodus-gold !text-black" : "border-exodus-border text-exodus-muted"}`}>Side by side</button>
        {BUCKETS.map((x) => (
          <button key={x.key} data-testid={`bucket-tab-${x.key}`} onClick={() => { setView("single"); setActive(x.key); }}
            className={`px-4 py-2 text-xs eyebrow border transition-colors ${view === "single" && active === x.key ? "border-exodus-gold bg-exodus-gold !text-black" : "border-exodus-border text-exodus-muted"}`}>
            {x.name}
          </button>
        ))}
      </div>

      {view === "compare" ? (
        <div className="overflow-x-auto border border-exodus-border">
          <table className="w-full min-w-[860px] text-sm">
            <thead>
              <tr>
                <th className="p-4 sm:p-5 text-left w-28 sm:w-48 bg-exodus-surface sticky left-0 z-10" />
                {BUCKETS.map((x) => (
                  <th key={x.key} className="p-5 text-left bg-exodus-surface border-l border-exodus-border align-top">
                    <span className="block h-1 w-10 mb-3" style={{ background: x.color }} />
                    <span className="font-display text-2xl font-normal text-exodus-text">{x.name}</span>
                    <span className="block text-xs text-exodus-muted font-normal mt-1">{x.examples}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.entries(ROW_LABELS).map(([k, label]) => (
                <tr key={k} data-testid={`bucket-row-${k}`} className="border-t border-exodus-border align-top">
                  <td className="p-4 sm:p-5 eyebrow !text-[9px] sm:!text-[10px] !tracking-[0.15em] sticky left-0 z-10 bg-exodus-bg w-28 sm:w-48">{label}</td>
                  {BUCKETS.map((x) => <td key={x.key} className="p-5 border-l border-exodus-border text-exodus-text/90 leading-relaxed"><Cell k={k} v={x.rows[k]} /></td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div data-testid={`bucket-detail-${b.key}`} className="card-surface p-6 sm:p-10 rise">
          <p className="font-display text-5xl" style={{ color: b.color }}>{b.n}</p>
          <h3 className="font-display text-3xl mt-2">{b.name}</h3>
          <p className="text-sm text-exodus-muted mt-2 max-w-2xl">{b.examples}</p>
          <div className="grid md:grid-cols-2 gap-x-10 gap-y-8 mt-10 text-sm leading-relaxed">
            {Object.entries(ROW_LABELS).map(([k, label]) => (
              <div key={k}><p className="eyebrow text-[10px] mb-2">{label}</p><div className="text-exodus-text/90"><Cell k={k} v={b.rows[k]} /></div></div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
